class TawktoWidget {
  initialize() {
    this.originalPushState = window.history.pushState.bind(window.history)
    this.originalReplaceState = window.history.replaceState.bind(window.history)
    document.addEventListener("turbo:load", () => this.ensureLoaded())
  }

  ensureLoaded() {
    const meta = document.querySelector("meta[name='tawkto-config']")
    if (!meta) return
    if (this.isWidgetPresent()) return

    const config = JSON.parse(meta.content)
    if (!config.propertyId) return

    this.resetTawkState()
    this.initializeWidget(config)
  }

  isWidgetPresent() {
    return document.querySelector('iframe[src*="tawk.to"], iframe[id^="tawkchat"], [class*="tawk-min"], [id*="tawkchat"]') !== null
  }

  resetTawkState() {
    this.restoreOriginalHistory()
    document.querySelectorAll('script[src*="embed.tawk.to"]').forEach(script => script.remove())
    Object.keys(window).forEach(key => {
      if (/^Tawk_/i.test(key) || /^\$_?Tawk/i.test(key)) {
        delete window[key]
      }
    })
  }

  restoreOriginalHistory() {
    window.history.pushState = this.originalPushState
    window.history.replaceState = this.originalReplaceState
  }

  initializeWidget(config) {
    window.Tawk_API = {}
    window.Tawk_LoadStart = new Date()
    window.Tawk_API.onLoad = () => this.restoreOriginalHistory()

    this.setVisitorData(config)
    this.injectScript(config)
  }

  setVisitorData(config) {
    window.Tawk_API.visitor = {
      name: config.name,
      email: config.email,
      hash: config.hash
    }
  }

  injectScript(config) {
    const script = document.createElement("script")
    script.async = true
    script.src = `https://embed.tawk.to/${config.propertyId}/${config.widgetId}`
    script.charset = "UTF-8"
    script.setAttribute("crossorigin", "*")
    document.head.appendChild(script)
  }
}

export default new TawktoWidget()
